import {
    ReactNode,
} from "react";
import useTableData, { ContainsId, SelectionChanged } from "./base";

export interface TableRowSelectorProps<T> {
    onSelectionChange?: SelectionChanged<T>;
    selection?: Set<string>;
}

function TableRowSelector<T extends ContainsId>(args: TableRowSelectorProps<T>): ReactNode {
    const data = useTableData<T>();
    data.useRowSelector(args.onSelectionChange, args.selection);

    return null;
}

TableRowSelector.defaultProps = {

};

export type Type<T> = (
    props: TableRowSelectorProps<T>
) => ReactNode;

export default TableRowSelector as Type<unknown>;
